import { render, staticRenderFns } from "./UnitStar.vue?vue&type=template&id=e003d9fe&"
import script from "./UnitStar.vue?vue&type=script&lang=js&"
export * from "./UnitStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e003d9fe')) {
      api.createRecord('e003d9fe', component.options)
    } else {
      api.reload('e003d9fe', component.options)
    }
    module.hot.accept("./UnitStar.vue?vue&type=template&id=e003d9fe&", function () {
      api.rerender('e003d9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VQuo3VWz53qf/JS/UnitStar.vue"
export default component.exports